import React, {useEffect, useState} from 'react';
import {
  Document,
  Page,
  View,
  Text,
  Link,
  Font,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
import ier_logo from '../../assets/images/icons/ier-logo2.png'
import moment from 'moment';


const styles = StyleSheet.create({
  title: {
    margin: 20,
    fontSize: 25,
    textAlign: 'center',
    backgroundColor: '#e4e4e4',
    textTransform: 'uppercase',
    fontFamily: 'Oswald',
  },
  title_container:{
    display: 'flex',
    flexDirection: 'row',
    padding: 20,
    backgroundColor: '#e7eaf3',
  },
  title_text:{
    fontSize: 10,
  },
  text_container:{
    flex: 1,
    marginLeft: 20
  },
  logo:{
    width: "100%"
  },
  header_title:{
    fontWeight: 'bold',
    fontSize: 20,
    color: '#0C8444',
    textTransform: 'uppercase'
  },
  body: {
    flexGrow: 1,
    padding: 20
  },
  row: {
    borderBottomWidth: 1,
    borderBottomColor: '#e4e4e4',
    paddingVertical: 15
  },
  content_title:{
    fontSize: 9,
  },
  content_sub_title:{
      fontSize: 14,
      fontWeight: 'bold'
  },
  content_container:{
    flexDirection: 'column', 
    justifyContent: 'space-between', 
    paddingTop: 10,
    width: '50%'
  },
  content_sub_container:{
    padding: '10px 0px'
  },
  seperator:{
      border: '2px dashed #D6D6D6'
  }
});

Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
});


export default (props) => {

    const [details, setDetails] = useState('')

    useEffect(()=>{ 
        setDetails(props.data)
    },[props.data])

return(
  <Document>
    <Page size="A4">
        <View style={styles.title_container}>
            <Image src={ier_logo} style={styles.logo}/>
        </View>
      <View style={styles.body}>
        <View style={styles.row}>
          <Text style={styles.header_title}>COMPANY DETAILS</Text>
          <View style={{flexDirection: 'row'}}>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Company names</Text>
                            <Text style={styles.content_sub_title}>{details?.companyNames || '-'}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Company activities</Text>
                            <Text style={styles.content_sub_title}>{details?.companyActivities || '-'}</Text>
                        </View>
                </View>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Date of business registration</Text>
                            <Text style={styles.content_sub_title}>{moment(details?.registrationDate).format('MMMM Do YYYY, h:mm:ss a') || '-'}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Business Certificate number</Text>
                            <Text style={styles.content_sub_title}>{details?.businessCertificateNumber || '-'}</Text>
                        </View>
                </View>
          </View>
        </View>

        <View style={styles.row}>
          <Text style={styles.header_title}>Contact details</Text>
          <View style={{flexDirection: 'row'}}>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Phone number</Text>
                            <Text style={styles.content_sub_title}>{details?.contactTelephoneNumber || ''}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Email address</Text>
                            <Text style={styles.content_sub_title}>{details?.contactEmail || '-'}</Text>
                        </View>
                </View>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Secondary Phone number</Text>
                            <Text style={styles.content_sub_title}>{details?.secondaryContactTelephoneNumber || '-'}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Main Email address</Text>
                            <Text style={styles.content_sub_title}>{details?.secondaryContactEmail || '-'}</Text>
                        </View>
                </View>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Residence Address</Text>
                                {details.residenceType === 'Local' ? 
                                <Text style={styles.content_sub_title}>
                                    {details.provinceId?.name}, 
                                    {details.districtId?.name}, 
                                    {details.sectorId?.name}, 
                                    {details.cellId?.name}, 
                                    {details.villageId?.name}, 
                                    {details.streetOrHouseNumber}
                                </Text>: 
                                <Text style={styles.content_sub_title}>
                                    {details.countryOfResidence?.name},
                                    {details.residenceAddress}
                                </Text>
                                }
                        </View>
                </View>
          </View>
        </View>



        <View style={styles.row}>
          <Text style={styles.header_title}>Company Directors/ Shareholders</Text>
          <>
            { details.stakeholders?.length> 0  &&  details.stakeholders?.map(value=>{
                return(
                    <>
                    <View style={{flexDirection: 'row'}}>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Full names</Text>
                                <Text style={styles.content_sub_title}>{value?.fullName}</Text>
                            </View>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Qualification</Text>
                                <Text style={styles.content_sub_title}>{value?.qualification}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Phone</Text>
                                <Text style={styles.content_sub_title}>{value?.telephoneNumber}</Text>
                            </View>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>National ID number</Text>
                                <Text style={styles.content_sub_title}>{value?.nationalIdNumber}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                                <View style={styles.content_sub_container}>
                                    <Text style={styles.content_title}>IER number</Text>
                                    <Text style={styles.content_sub_title}>{value?.ierMemberNumber}</Text>
                                </View>
                        </View>
                    </View>
                    <View style={styles.seperator}></View>
                    </>
                )
            })  
            }
          </>
        </View>



        <View style={styles.row}>
          <Text style={styles.header_title}>Projects accomplished details</Text>
        { details.projects?.length> 0 &&  details.projects.map(value=>{
            return(
                <>
                <View style={{flexDirection: 'row'}}>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Name of the project</Text>
                                <Text style={styles.content_sub_title}>{value.name}</Text>
                            </View>
                    </View>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Client</Text>
                                <Text style={styles.content_sub_title}>{value.client}</Text>
                            </View>
                    </View>
                </View>
                <View style={styles.seperator}></View>
                </>
            )
        })
         }
        </View>
        <View style={styles.row}>
          <Text style={styles.header_title}>Attachments</Text>
                <View style={{flexDirection: 'row'}}>
                    <View style={styles.content_container}>
                          <View style={styles.content_sub_container}>
                              <Text style={styles.content_title}>Technical report</Text>
                              <Text style={styles.content_sub_title}>{details.technicalReportFile?.name || '-'}</Text>
                          </View>
                    </View>
                    <View style={styles.content_container}>
                          <View style={styles.content_sub_container}>
                              <Text style={styles.content_title}>certified Business certificate</Text>
                              <Text style={styles.content_sub_title}>{details.businessCertificateDocumentFile?.name || '-'}</Text>
                          </View>
                    </View>
                    <View style={styles.content_container}>
                          <View style={styles.content_sub_container}>
                              <Text style={styles.content_title}>RDB Registration Certificate</Text>
                              <Text style={styles.content_sub_title}>{details.rdbRegistrationDocumentFile?.name || '-'}</Text>
                          </View>
                    </View>
                </View>
                <View style={{flexDirection: 'row'}}>
                    <View style={styles.content_container}>
                          <View style={styles.content_sub_container}>
                              <Text style={styles.content_title}>Managing/Technical Director’s Practicing License</Text>
                              <Text style={styles.content_sub_title}>{details.practicingLicenseDocumentFile?.name || '-'}</Text>
                          </View>
                    </View>
                    <View style={styles.content_container}>
                          <View style={styles.content_sub_container}>
                              <Text style={styles.content_title}>Company Profile</Text>
                              <Text style={styles.content_sub_title}>{details.companyProfileDocumentFile?.name || '-'}</Text>
                          </View>
                    </View>
                    <View style={styles.content_container}>
                          <View style={styles.content_sub_container}>
                              <Text style={styles.content_title}>RSSB Certificate</Text>
                              <Text style={styles.content_sub_title}>{details.rssbCertificateDocumentFile?.name || '-'}</Text>
                          </View>
                    </View>
                </View>
                <View style={{flexDirection: 'row'}}>
                    <View style={styles.content_container}>
                          <View style={styles.content_sub_container}>
                              <Text style={styles.content_title}>RRA Tax Clearance Certificate</Text>
                              <Text style={styles.content_sub_title}>{details.taxClearanceDocumentFile?.name || '-'}</Text>
                          </View>
                    </View>
                </View>
        </View>

      </View>
    </Page>
  </Document>
)
};